import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRightCircleFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4848_987x)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17 0C26.3888 0 34 7.61116 34 17C34 26.3888 26.3888 34 17 34C7.61116 34 0 26.3888 0 17C0 7.61116 7.61116 0 17 0ZM17.707 10.293C17.3165 9.90244 16.6835 9.90244 16.293 10.293C15.9024 10.6835 15.9024 11.3165 16.293 11.707L20.5859 16H11C10.4477 16 10 16.4477 10 17C10 17.5523 10.4477 18 11 18H20.5859L16.293 22.293C15.9024 22.6835 15.9024 23.3165 16.293 23.707C16.6835 24.0976 17.3165 24.0976 17.707 23.707L23.707 17.707C24.0976 17.3165 24.0976 16.6835 23.707 16.293L17.707 10.293Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4848_987x",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 34,
			height: 34,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgArrowRightCircleFilled);
export { ForwardRef as ReactComponent };
